import { Component } from '@angular/core';
import { AlarmHistoryTableRowComponent } from '@components/alarm-history-table-row/alarm-history-table-row.component';

@Component({
    selector: 'app-alarm-history-table-row-compact',
    templateUrl: './alarm-history-table-row-compact.component.html',
    styleUrls: [
        './alarm-history-table-row-compact.component.css',
        '../alarm-history-table-row/alarm-history-table-row.component.css',
        '../alarm-table-row/alarm-table-row.component.scss',
    ],
    standalone: false
})
export class AlarmHistoryTableRowCompactComponent extends AlarmHistoryTableRowComponent {}
